module.exports = __webpack_public_path__ + "img/copy-regular.e4fce489.svg";